/**
 * add sticky text size control ui to right side of viewport
 */
const setupTextSizeControls = () =>
{
	const html        = document.querySelector( 'html' );
	const plusButton  = document.querySelector( '#text-size-controls .plus' );
	const minusButton = document.querySelector( '#text-size-controls .minus' );
	let percent       = 100;

	if (plusButton instanceof HTMLElement && minusButton instanceof HTMLElement) {

		plusButton.addEventListener( 'click', e =>
		{
			e.preventDefault();

			percent += 10;
			html.style.fontSize = percent + '%';
		} );

		minusButton.addEventListener( 'click', e =>
		{
			e.preventDefault();

			percent -= 10;
			html.style.fontSize = percent + '%';
		} );
	}
};


/**
 *
 */
export default setupTextSizeControls;